import { Component, OnInit } from '@angular/core';

import { environment } from '../../../environments/environment';

import { DocsService } from '../../services/docs.service';

@Component({
    selector: 'kd-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

    breadcrumbs: Array<string>;
    label: string = environment.label;

    constructor(
        private docsService: DocsService,
    ) { }

    ngOnInit() {
        this.init();
        this.docsService.getPageChange().subscribe(() => {
            this.init();
        });
    }

    private init(): void {
        this.breadcrumbs = this.docsService.getBreadcrumbs();
    }
}
